
/* Common: ADI use case loader */
ADILF.define('adilf/util/page-loader',[
        'require',
        'streamhub-sdk/jquery', 
        'adilf/context', 
        'adilf/debug',
        'promise-polyfill'
    ],
    function(require, jquery, Context, Debug, PromisePolyfill) {
    "use strict";

    var Promise = window.Promise || PromisePolyfill; // Use Polyfill if no native support (IE, PhantomJS)

    var _jquery_url = '//static.advance.net/static/common/js/libs/jquery-1.8.2.min.js'

    var loader = function(module) {
        return loader._load(module);
    };

    loader._loadGlobalJQuery = function() {
      return new Promise(function(resolve, reject) {
        var self = this;
        if (!window.jQuery) {
            self._blocked = true;
            var jqScript = document.createElement('script');
            jqScript.src = _jquery_url;
            jqScript.type = 'text/javascript';
            jqScript.async = 'true';
            jqScript.onload = jqScript.onreadystatechange = function() {
                var jqReadyState = this.readyState;
                if (!self._blocked || jqReadyState && jqReadyState != 'complete' && jqReadyState != 'loaded') {
                    return;
                }
                self._blocked = false;
                resolve(true);
            };
            var jqTarget = document.getElementsByTagName('script')[0];
            jqTarget.parentNode.insertBefore(jqScript, jqTarget);
        } else {
            resolve(true);
        }
      });
    };

    loader._load = function(module) {
        if(!module) { return false; }
        try {
            Context.page.module = module;
            require([module], function (PageModule) {
                PageModule.debug = new Debug(module);
                /* istanbul ignore else */
                if(typeof PageModule.init === 'function') { PageModule.init(); }
            });
        } catch (e) {
            /* istanbul ignore next */
            return (function(){
                var d = new Debug("page-loader failed");
                d.error("Everything is terrible");
                return false;
            })();
        }
    };

    loader.autoLoad = function() {
        var adilf_script = jquery("#adilf");
        if(adilf_script.length > 0) {
            loader._loadGlobalJQuery().then(function(success) {
                var autoModule = "adilf/" + adilf_script.attr("data-start");
                return loader._load(autoModule);
            }, function(error) {
                var d = new Debug("page-loader failed");
                d.error("Failure loading or resolving jQuery - everything is terrible");
                return false;
            });
        } else {
            return false;
        }
    };

    return loader;
});